import { render, staticRenderFns } from "./sidebarMenusList.vue?vue&type=template&id=67eabc2e&"
import script from "./sidebarMenusList.vue?vue&type=script&lang=js&"
export * from "./sidebarMenusList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports